import React from 'react'

import SelectTeamMember from '@/components/select/SelectTeamMember'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import { cn } from '@/lib/utils'
import {
  selectLogHistoricalReferralState,
  setSelectedUser,
} from '@/redux/slices/logHistoricalReferral'

interface Props {
  className?: string
  disabled?: boolean
}

const SelectReferringUser: React.FC<Props> = ({
  className,
  disabled = false,
}) => {
  const dispatch = useAppDispatch()
  const referralLogHistoricalState = useAppSelector(
    selectLogHistoricalReferralState,
  )

  return (
    <div className={cn('relative', className)}>
      <div className="z-100">
        <SelectTeamMember
          isDisabled={disabled}
          isClearable={false}
          selected={referralLogHistoricalState.selectedUser}
          onSelect={(selectedUser) => {
            dispatch(setSelectedUser(selectedUser))
          }}
        />
      </div>
    </div>
  )
}

export default SelectReferringUser
